/* __next_internal_client_entry_do_not_use__ Label,Pill,CloseButton auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import { Typography, TypographyStyles } from "@faire/web--source/slate/Typography";
import React from "react";
import styled, { css } from "styled-components";
import { Close } from "../icons/foundation/Close";
import { themeOrDefault } from "../Theme";
import { responsiveMediaQueries } from "../Theme/responsiveMediaQueries";
import { HIGH_VIS_FILTER, highVisSlateComponent } from "../utils/highVisSlateComponent";
export var Label = styled(Typography).withConfig({
    componentId: "sc-239c3d46-0"
})([
    "",
    ""
], function(param) {
    var theme = param.theme;
    var _theme_pills_tag, _theme_pills;
    var _theme_pills_tag_label;
    return TypographyStyles((_theme_pills_tag_label = (_theme_pills = theme.pills) === null || _theme_pills === void 0 ? void 0 : (_theme_pills_tag = _theme_pills.tag) === null || _theme_pills_tag === void 0 ? void 0 : _theme_pills_tag.label) !== null && _theme_pills_tag_label !== void 0 ? _theme_pills_tag_label : {});
});
export var Pill = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-239c3d46-1"
})([
    "padding:2px 8px 2px 16px;min-height:28px;",
    ";",
    ""
], function(param) {
    var theme = param.theme, onClick = param.onClick;
    var pills = themeOrDefault(theme).pills;
    var regular = pills.tag.background.color;
    var hover = pills.tag.background.hover;
    var regularLetter = pills.tag.background.contrast;
    var pointer = onClick ? "pointer" : undefined;
    return css([
        "cursor:",
        ";background-color:",
        ";color:",
        ";",
        "{&:hover{background-color:",
        ";}"
    ], pointer, regular, regularLetter, responsiveMediaQueries.desktopAndAbove, hover);
}, highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
Pill.displayName = "Pill";
var CloseContainer = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-239c3d46-2"
})([
    "width:24px;height:24px;padding:7px;cursor:pointer;"
]);
/* eslint-disable @faire/enforce-no-supersededby-components */ /**
 * @trackcomponent
 * @supersededBy "@faire/web--source/slate/IconButton/IconButton#IconButton"
 */ export var CloseButton = function(props) {
    var handleClick = function(event) {
        event.stopPropagation();
        event.preventDefault();
        props.onClose();
    };
    return /*#__PURE__*/ _jsx(CloseContainer, {
        onClick: handleClick,
        "data-test-id": props["data-test-id"],
        children: /*#__PURE__*/ _jsx(Close, {
            fontSize: "8px",
            strokeWidth: 2,
            color: Core.icon.default
        })
    });
};
